import React from "react";
import CustomCheckbox from "./CustomCheckbox";
import { SET_FUTURE_MAX_CONTRACTS, SET_FUTURE_MAX_CONTRACTS_RENT } from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LeftRightForm from "./LeftRightForm";
import { max } from "moment";
import { eligibleMaxContracts } from "../../../../utils/Utils";
import TutorialPopup from "../../../help/TutorialPopup";

const MaxContracts = (props)=>{
    const {rent} = props
    const newBot = useSelector((state) => state.createBot.newBot);
    const rentBot = useSelector((state) => state.createBot.rentBot);
    //const selectedExchange = rent?newBot.exchange:rentBot.exchange;
    const selectedExchange = useSelector(
            (state) => state.settings.selectedExchange
    );
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const setMaxContracts = (val) => {
        dispatch({
          type: rent?SET_FUTURE_MAX_CONTRACTS_RENT:SET_FUTURE_MAX_CONTRACTS,
          payload: val,
        });
      };
    const  restrictAlphabets = (e)=>{
      var x = e.which || e.keycode;
      if(!(x>=46 && x<=57))
      e.preventDefault()

    }
    return(<>
    {eligibleMaxContracts(selectedExchange) &&
           <LeftRightForm 
            left={<>
            <h6>{t("max-contracts")} <TutorialPopup content={t("max-contracts-help")} /></h6>
            
            </>}
            right={  
              <input
                value={rent?rentBot.futureMaxContracts:newBot.futureMaxContracts}
                onChange={(e) => setMaxContracts(e.target.value)}
                className=""
                type="text"
                onKeyPress={(e) => {
                  restrictAlphabets(e);
                }}
              />
             }
            >
            </LeftRightForm>}
    </>)
}

export default MaxContracts;